// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ProfileReducer from "./ProfileReducer.bs.js";

var state_reducer = {
  state: ProfileReducer.initial_state,
  dispatch: (function (param) {
      
    })
};

var state = {
  reducer: state_reducer,
  lead_in_channel: ""
};

var context = React.createContext(state);

var provider = context.Provider;

function ProfileContext$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var Provider = {
  provider: provider,
  make: ProfileContext$Provider
};

export {
  state ,
  context ,
  Provider ,
  
}
/* context Not a pure module */
